export default __webpack_public_path__ + "9fefa52a4d05d524eab1c6cac982aec6.png";